<template>
    <vProjectPreview :views="views" v-model="chosenView">
        <CardEmpty
            v-if="!nda.id && isNdaView"
            class="w-full"
            :title="$t('legal.nda.preview.title')"
            :icon="emptyIcon"
            :ctaIcon="arrowIcon"
            :ctaLabel="$t('legal.nda.preview.cta')"
            @add="showNdaList"
        />
        <vPreviewIframe v-else :back="footer.background" :src="previewSrc" />
    </vProjectPreview>
</template>

<script>
import { markRaw } from "vue";
import { LEGAL_ROUTE_NAMES, LEGAL_PREVIEW_KIND } from "@/apps/legal/legal.routes";
import { mapActions, mapMutations, mapState } from "vuex";
import { FooterIcon, TextFileIcon, ChevronDoubleLeftIcon } from "@easy/ui/icons";
import { CardEmpty } from "@easy/ui/cards";
import vPreviewIframe from "@/shared/views/vPreviewIframe.vue";
import vProjectPreview from "@/shared/views/vProjectPreview.vue";

export default {
    components: {
        CardEmpty,
        vPreviewIframe,
        vProjectPreview,
    },
    mounted() {
        this.$watch(
            () => [
                this.footer,
                this.legal,
                this.categories,
                this.size,
                this.chosenView,
                this.lang,
                this.nda,
            ],
            () => this.refreshIframe(),
            {
                immediate: true,
                deep: true,
            }
        );
        this.$watch(
            () => this.chosenView,
            () => this.setIframeLoaded(false)
        );
    },
    data() {
        return {
            chosenView: LEGAL_PREVIEW_KIND.terms,
        };
    },
    computed: {
        ...mapState(["lang"]),
        ...mapState("legal", ["footer", "legal", "categories"]),
        ...mapState("legal/ndas", ["nda"]),
        emptyIcon() {
            return markRaw(TextFileIcon);
        },
        arrowIcon() {
            return markRaw(ChevronDoubleLeftIcon);
        },
        views() {
            return [
                {
                    label: this.$t("legal.views.terms"),
                    value: LEGAL_PREVIEW_KIND.terms,
                    icon: TextFileIcon,
                },
                {
                    label: this.$t("legal.views.privacy"),
                    value: LEGAL_PREVIEW_KIND.privacy,
                    icon: TextFileIcon,
                },
                {
                    label: this.$t("legal.views.about"),
                    value: LEGAL_PREVIEW_KIND.about,
                    icon: TextFileIcon,
                },
                {
                    label: this.$t("legal.views.footer"),
                    value: LEGAL_PREVIEW_KIND.footer,
                    icon: FooterIcon,
                },
                {
                    label: this.$t("legal.views.nda"),
                    value: LEGAL_PREVIEW_KIND.nda,
                    icon: TextFileIcon,
                },
            ];
        },
        isFooterView() {
            return this.chosenView === LEGAL_PREVIEW_KIND.footer;
        },
        isTermsView() {
            return this.chosenView === LEGAL_PREVIEW_KIND.terms;
        },
        isPrivacyView() {
            return this.chosenView === LEGAL_PREVIEW_KIND.privacy;
        },
        isAboutView() {
            return this.chosenView === LEGAL_PREVIEW_KIND.about;
        },
        isNdaView() {
            return this.chosenView === LEGAL_PREVIEW_KIND.nda;
        },
        previewSrc() {
            return this.isFooterView
                ? `/preview/footers/${this.footer.uuid}`
                : this.isTermsView
                  ? `/preview/terms/${this.legal.uuid}`
                  : this.isPrivacyView
                    ? `/preview/policies/${this.legal.uuid}`
                    : this.isAboutView
                      ? `/preview/about/${this.legal.uuid}`
                      : this.isNdaView
                        ? `/preview/nda/${this.footer.uuid}/${this.nda.uuid}`
                        : "";
        },
        fontFamilyStyle() {
            return { "font-family": this.footer.fontFamily };
        },
    },
    methods: {
        ...mapMutations("legal", ["setIframeLoaded"]),
        ...mapActions("legal", ["refreshIframe"]),
        showNdaList() {
            this.routeTo(LEGAL_ROUTE_NAMES.projectDocumentsNda, LEGAL_PREVIEW_KIND.nda);
        },
        routeTo(name, forcedView) {
            const { query } = this.$route;
            this.$router.push({ name, query: forcedView ? { ...query, view: forcedView } : query });
        },
    },
};
</script>
